'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";
import CountrySelectController from "./controller/countrySelect";
import CountriesController from "./controller/countries";
import CountryModalCreateController from "./controller/countryModalCreate";
import CountryTableDirective from "./directive/countryTable";
import CountryService from "./service/country";

export default angular.module('investmentProject.country', [])
    .controller('CountrySelectController', CountrySelectController)
    .controller('CountriesController', CountriesController)
    .controller('CountryModalCreateController', CountryModalCreateController)
    .directive('countryTable', CountryTableDirective)
    .factory('CountryService', CountryService)
    .name;
